import { defineMessages } from 'react-intl'

export default defineMessages({
  viewDetailsHint: {
    id: 'FeaturesHistoryPage.viewDetailsHint',
    defaultMessage: 'View execution details for {for}'
  },
  loading: {
    id: 'FeaturesHistoryPage.Loading',
    defaultMessage: 'Loading...'
  },
  seconds: {
    id: 'FeaturesHistoryPage.Seconds',
    defaultMessage: `seconds`
  },
  duration: {
    id: 'FeaturesHistoryPage.Duration',
    defaultMessage: `Duration:`
  },
  backToApp: {
    id: 'FeaturesHistoryPage.BackToApp',
    defaultMessage: `Back to App Instance`
  },
  dateTime: {
    id: 'FeaturesHistoryPage.DateTime',
    defaultMessage: `Date/Time Run`
  },
  condition: {
    id: 'FeaturesHistoryPage.Condition',
    defaultMessage: `Condition`
  },
  refresh: {
    id: 'FeaturesHistoryPage.Refresh',
    defaultMessage: `Refresh`
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  }
})
